<div class="slice-control">
  <button class="b-button slice-control__previous-slice" (click)="previousSlice()">
    {{sliceOrder | dashboardStudyViewerZoomedControlsSliceName: currentSliceIndex : 'previous'}}
  </button>

  <div class="slice-control__current-slice">
    {{sliceOrder | dashboardStudyViewerZoomedControlsSliceName: currentSliceIndex : 'current'}}
  </div>

  <button class="b-button slice-control__next-slice" (click)="nextSlice()">
    {{sliceOrder | dashboardStudyViewerZoomedControlsSliceName: currentSliceIndex : 'next'}}
  </button>
</div>
